<!-- Dialog -->
<div class="dialog">
    <mat-icon (click)="moveImage(-1)" class="mat-icon-left">chevron_left</mat-icon>
    <mat-icon (click)="moveImage(1)" class="mat-icon-right">chevron_right</mat-icon>
    <div mat-dialog-content>
        <div class="username">
            <a title="Go to instagram" target="_blank"
                href="https://www.instagram.com/{{userInstagramData.data[selectedImage].username}}"
                rel="noopener">{{userInstagramData.data[selectedImage].username}}</a>
            <a title="Go to instagram" target="_blank"
                href="https://www.instagram.com/{{userInstagramData.data[selectedImage].username}}" rel="noopener"><img
                    title="Go to instagram"
                    src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/logos/instagram.png" /></a>
        </div>
        <div class="caption">{{userInstagramData.data[selectedImage].caption}}</div>
        <div class="img-container">
            <img *ngIf="userInstagramData.data[selectedImage].media_type=='IMAGE'"
                src="{{userInstagramData.data[selectedImage].media_url}}" alt="">
            <video *ngIf="userInstagramData.data[selectedImage].media_type=='VIDEO'" autoplay controls 
                style='max-height: 75%; max-width: 70%;display: block !important;margin: auto;'>
                <source src='{{ userInstagramData.data[selectedImage].media_url }}' type='video/mp4'>
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
</div>
<div class="exit-dialog" (click)="close()">
    <app-material-exit-dialog></app-material-exit-dialog>
</div>